<template>
    <div class="dashboard-page-container">
        <div class="dashboard-page-content"
        :class="{'content-no-top':noTopSpace, [contentClass]: !!contentClass}" :style="{
            'padding-top': `${topPadding}px`
        }" :id="contentId">
            <slot></slot>

            <portal-target name="iqos-tooltip-portal">
            </portal-target>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        noTopSpace: {
            type:Boolean,
            default:false
        },
        topPadding: {
            type: Number,
            default: 16
        },
        contentClass: {
            type: String
        },
        contentId: {
            type: String,
            default: null
        }
    }
}
</script>

<style>
.dashboard-page-container {
    max-height: 100%;
    width: 100%;
    overflow-y: auto;
}

.dashboard-page-content {
    padding: 16px 32px 32px 32px;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
}

.content-no-top {
    padding-top: 0;
}
</style>
